import React from 'react';

export interface IRoute {
  path: string;
  exact?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: () => Promise<{ default: React.ComponentType<any> }>;
  routes?: IRoute[];
}

export interface RouteProps extends Omit<IRoute, 'component' | 'routes'> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  routes?: RouteProps[];
}

const routes: IRoute[] = [
  {
    path: '/',
    exact: true,
    component: () => import(/* webpackChunkName: "home" */ '@/pages/home')
  },
  // {
  //   path: '/login',
  //   component: () => import(/* webpackChunkName: "login" */ '@/pages/login')
  // },
  {
    path: '/im',
    component: () => import(/* webpackChunkName: "im" */ '@/pages/im')
  },
  {
    path: '/im/online',
    component: () => import(/* webpackChunkName: "im" */ '@/pages/im')
  },
  {
    path: '/im-redirect',
    component: () => import(/* webpackChunkName: "im-redirect" */ '@/pages/im/redirect')
  },
  {
    path: '/pc/im',
    component: () => import(/* webpackChunkName: "im" */ '@/pages/im')
  }
];

const transformComponent = (routeList: IRoute[]): RouteProps[] =>
  routeList.map(route => ({
    ...route,
    component: React.lazy(route.component),
    routes: route.routes ? transformComponent(route.routes) : undefined
  }));

export default transformComponent(routes);
